<script setup lang="ts">
defineOptions({ inheritAttrs: false });

import { computed } from "vue";
import { useListItem } from "@/hooks";

const props = defineProps<{ property: string }>();
const emit = defineEmits(["change"]);
const { item, index } = useListItem();
const cmpData = computed(() =>
  item.value ? item.value[props.property] : undefined
);

function onChange(value: any) {
  if (!item.value) return;
  item.value[props.property] = value;
  emit("change", { rowIndex: index.value, value });
}
</script>
<template>
  <nut-checkbox v-bind="$attrs" :modelValue="cmpData" @change="onChange">
    <template #default v-if="$slots.default"><slot name="default" /></template>
    <template #icon v-if="$slots.icon"><slot name="icon" /></template>
    <template #checkedIcon v-if="$slots.checkedIcon">
      <slot name="checkedIcon" />
    </template>
    <template #indeterminate v-if="$slots.indeterminate">
      <slot name="indeterminate" />
    </template>
  </nut-checkbox>
</template>
